<template>
  <div id="searchBar">
    <v-form>
      <v-row>
        <v-col>
          <v-text-field
            label="Rechercher"
            v-model="searchString"
            @input="onSearchStringChanged"
            name="searchInput"
            id="searchInput"
          >
          </v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <v-list two-line
      v-if="mapLocationCollectionFiltered.length > 0"
    >
      <v-subheader>RESULTATS</v-subheader>
      <v-list-item-group
        v-model="selectedItem"
        color="primary"
      >
        <v-list-item
          v-for="(suggestedMapLocation, index) in mapLocationCollectionFiltered"
          :key="index"
          @click="suggestionClick(suggestedMapLocation)"
        >
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary" v-text="suggestedMapLocation.name" />
            <v-list-item-subtitle v-text="suggestedMapLocation.desc"/>
          </v-list-item-content>
          <v-list-item-action v-if="suggestedMapLocation.url !== ''" @click="linkClick(suggestedMapLocation)">
              <v-list-item-action-text>Voir l'article</v-list-item-action-text>
                <v-icon>mdi-link</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    mapLocationCollection: {
      required: true,
    },
  },
  data() {
    return {
      searchString: "",
    };
  },
  computed: {
    mapLocationCollectionFiltered: function () {
      return this.mapLocationCollection.find(this.searchString);
    },
  },
  methods: {
    onSearchStringChanged() {
      console.log(this.mapLocationCollection.find(this.searchString));
    },
    suggestionClick(suggestedMapLocation) {
      this.$emit("change", suggestedMapLocation);
    },
    linkClick(suggestedMapLocation) {
      window.open(suggestedMapLocation.url, "_blank"); 
    }
    
  },
};
</script>

<style>
</style>